module.exports = __webpack_public_path__ + "img/spectrum-logo.21e95ac6.jpg";